import React, { useRef, useContext } from 'react'
import { useInfiniteHits, useSearchBox } from 'react-instantsearch'
import searchIcon from 'svgs/search-icon-white.svg'
import { navigate } from 'gatsby'
import AppContext from 'context/app'

export const onSubmit = (e, query, items) => {
    if(e) e.preventDefault()
    // console.log(query, items)
    navigate(`/search?query=${query}`)
}

export default function Search({ style }) {
    const { clientWidth, overlay, setOverlay } = useContext(AppContext)
    const { query, refine } = useSearchBox()
    const { items } = useInfiniteHits()
    
    const inputRef = useRef(null)
    const isSearch = overlay === 'Search'

    return (
        <div
            style={style}
            css={{
                display: 'flex',
                alignItems: 'center',
                flexGrow: 1,
                border: 0,
                padding: 0,
                marginLeft: isSearch ? 32 : 0,
                borderRadius: isSearch ? 48 : 0,
                minWidth: isSearch ? 'auto' : 48
            }}
        >
            {isSearch && (
                <form
                    onSubmit={e => onSubmit(e, query, items)}
                    className='flex-1 d-flex j-center'
                >
                    <input
                        id='navbar-search'
                        type='search'
                        ref={inputRef}
                        onChange={e => refine(e.target.value)}
                        value={query}
                        placeholder={clientWidth > 576 ?
                            'What are you looking for today?' :
                            'Search'
                        }
                        autoFocus
                        className='bg-0 w-100 f-secondary'
                        css={{
                            padding: '10px 12px 10px 16px',
                            border: '.5px solid white',
                            borderRadius: 40,
                            maxWidth: 562,
                            fontSize: 16,
                            '::placeholder': { fontSize: 14 },
                            '&:focus-visible': { outline: 'none' },
                        }}
                    />
                </form>
            )}

            {/* MAGNIFYING GLASS */}
            <button
                className='bg-0 b-0 p-0 h-100 pointer'
                style={{ width: 48 }}
                onClick={e => {
                    if(!query && overlay === 'Search'){
                        inputRef.current.focus()
                    } else if(query && overlay === 'Search') {
                        onSubmit(e, query, items)
                    } else {
                        setOverlay('Search')
                    }
                }}
            >
                <img src={searchIcon} alt='' />
            </button>
        </div>
    )
}
